import Statistic from './statistic';

const statisticConfig = {
  name: 'statistic',
  class: Statistic,
  querySelector: {},
  querySelectorAll: {
    countUpTargets: '[data-countup]',
  },
  options: {},
};

export default statisticConfig;



// WEBPACK FOOTER //
// ./client/src/components/statistic/index.js